function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export const orderParams = [{
  api: 'name',
  slug: 'abc',
  name: 'Orden alfabético',
  label: 'Orden alfabético',
  hint: 'Orden alfabético',
  sort: (first, second) => second.name.toLowerCase() < first.name.toLowerCase() ? 1 : -1
}, {
  api: 'stats/funds',
  slug: 'fundsQty',
  name: 'Número de fondos',
  label: 'Número de fondos',
  hint: 'Número de fondos',
  sort: (first, second) => second.stats.funds < first.stats.funds ? -1 : 1
}, {
  api: 'stats/assets',
  slug: 'assets',
  name: 'Patrimonio gestionado',
  label: 'Patrimonio gestionado',
  hint: 'Patrimonio gestionado',
  sort: (first, second) => second.stats.assets < first.stats.assets ? -1 : 1
}];
export const getManagementCompaniesCategories = managementCompanies => {
  const categories = {};
  for (let i = 0; i < managementCompanies.length; i++) {
    const company = managementCompanies[i].categories;
    for (let j = 0; j < company.length; j++) {
      const category = company[j];
      if (!categories[category.id]) {
        const qty = {
          qty: 1
        };
        categories[category.id] = _objectSpread(_objectSpread({}, category), qty);
      } else {
        const qty = {
          qty: categories[category.id].qty + 1
        };
        categories[category.id] = _objectSpread(_objectSpread({}, category), qty);
      }
    }
  }
  return Object.values(categories).sort((first, second) => second.qty - first.qty);
};
export const reduceManagementCompanies = (managementCompanies, categories) => {
  if (!categories.length) {
    return managementCompanies;
  }
  const id = parseInt(categories[0]);
  const companies = [];
  for (let i = 0; i < managementCompanies.length; i++) {
    const company = managementCompanies[i];
    const categoriesIDs = company.categories.map(elem => elem.id);
    const foundCategories = company.categories.filter(cat => cat.id === id);
    if (foundCategories.length) {
      companies.push(company);
    }
  }
  return companies;
};